import React from 'react';
import { FormattedMessage } from 'react-intl';
import logo from './logo.jpg';
import styles from './index.module.less';

const Hero: React.FC = () => (
  <div className={styles.wrapper}>
    <img className={styles.video} src={logo} alt="logo" />
    <div className={styles.cover}>
      <div className={styles.title}>
        <FormattedMessage id="Privacy.Support" />
      </div>
    </div>
  </div>
);

export default Hero;
